import { render, staticRenderFns } from "./StatusCell.vue?vue&type=template&id=2c641008"
import script from "./StatusCell.vue?vue&type=script&lang=js"
export * from "./StatusCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports